import React from 'react'
import { HashRouter, Route, Router, Routes } from 'react-router-dom'
import DatosPersonales from './Docentes/IndexPersonales'
import Cpem46 from './cpem46'
import AgregarDocentes from './Docentes/AgregarDocentes'
import ModDocente from './Docentes/ModDocente'

const IndexPrincipal = () => {
  return (
    <div>

        <HashRouter>
            
            <Routes>

                <Route path='/' element={<Cpem46/>}/>


                <Route path='/IndexPersonales' element={<DatosPersonales/>}/>
                <Route path='/AgregarDocentes' element={<AgregarDocentes/>}/>


            </Routes>

        </HashRouter>
    
    </div>
  )
}

export default IndexPrincipal